import {CartType, ProductShoppingCart, ShoppingCart} from "./cart.dto";
import * as jsonpatch from 'fast-json-patch';
import ApiHttpClient from "@/HttpClient";

const getHeaders = () => ({
    'Content-Type': 'application/json-patch+json',
});

export const getCart = async (isPickup?: boolean): Promise<CartType | null> => {
    const client = await ApiHttpClient();
    const url = isPickup !== undefined
        ? `/shoppingCart?isPickup=${isPickup}`
        : `/shoppingCart`;
    const response = await client.get<CartType>(url);
    if (response.status === 404) return null;
    return response.data;
};

export const addItemToCart = async (cart: ShoppingCart, item: ProductShoppingCart, isTransit: boolean): Promise<any> => {
    const newCart = structuredClone(cart);

    if (isTransit) {
        newCart.items.transitItems.push(item);
    } else {
        newCart.items.stockItems.push(item);
    }

    const patch = jsonpatch.compare(cart, newCart);
    const response = await ApiHttpClient().patch(`/shoppingCart`, patch,
        {
            headers: getHeaders(),
        });

    if (response.status === 200) {
        return await getCart();
    }

    return cart;
};

export const removeItemFromCart = async (cart: ShoppingCart, itemId: number, isTransit: boolean): Promise<any> => {
    const newCart = structuredClone(cart);

    if (isTransit) {
        newCart.items.transitItems = cart.items.transitItems.filter(item => item.articleId !== itemId) as ProductShoppingCart[];
    } else {
        newCart.items.stockItems = cart.items.stockItems.filter(item => item.articleId !== itemId) as ProductShoppingCart[];
    }

    const patch = jsonpatch.compare(cart, newCart);

    const response = await ApiHttpClient().patch(`/shoppingCart`, patch,
        {
            headers: getHeaders(),
        });

    if (response.status === 200) {
        return await getCart();
    }

    return cart;
};

export const updateItemQuantity = async (cart: ShoppingCart, itemId: number, quantity: number, isTransit: boolean): Promise<any> => {
    let newCart = structuredClone(cart);

    if (isTransit) {
        newCart.items.transitItems = cart.items.transitItems.map(item =>
            item.articleId === itemId ? {...item, quantity} : item
        ) as [ProductShoppingCart];
    } else {
        newCart.items.stockItems = cart.items.stockItems.map(item =>
            item.articleId === itemId ? {...item, quantity} : item
        ) as [ProductShoppingCart];
    }

    const patch = jsonpatch.compare(cart, newCart);
    const response = await ApiHttpClient().patch(`/shoppingCart`, patch,
        {
            headers: getHeaders(),
        });

    if (response.status === 200) {
        return await getCart();
    }

    return cart;
};

export const updateDeliveryMethod = async (cart: CartType, isPickup: boolean): Promise<CartType | null> => {
    const newCart = { ...cart, isPickup };
    
    const patch = jsonpatch.compare(cart, newCart);

    const response = await ApiHttpClient().patch(`/shoppingCart`, patch, {
        headers: getHeaders(),
    });

    if (response.status === 200) {
        return await getCart(isPickup);
    }

    return cart;
};

